import {Component, Input} from '@angular/core';
import {ToastService} from '../../../../../@core/services/toast.service';
import {StorageService} from '../../../../../@core/services/storage.service';
import {CompanyResponse, UserEntityRelationWithoutUserDataResponse} from '../../../../models/response.module';

@Component({
  selector: 'app-header-company-select',
  standalone: false,
  templateUrl: './header-company-select.html',
  styleUrl: './header-company-select.css'
})
export class HeaderCompanySelect {
  @Input() companies: CompanyResponse[]
  currentCompany: UserEntityRelationWithoutUserDataResponse

  constructor(private storageService: StorageService,
              private toastService: ToastService) {
  }


  ngOnInit() {
    this.currentCompany = this.storageService.getSelectedCompany()
  }

  switchCompany(company: CompanyResponse) {
    const payload: UserEntityRelationWithoutUserDataResponse = {
      entity_id: company!.company_id,
      entity_name: company!.company_name,
      role_id: 1,
      role_name: 'Admin',
      created_at: company!.created_at,
      updated_at: company!.updated_at,
      deleted_at: company!.deleted_at,
    }
    this.storageService.saveSelectedCompany(payload);
    this.currentCompany = payload;
  }

  checkSelectedCompany(company: CompanyResponse) {
    return this.currentCompany?.entity_id == company.company_id;
  }

}
